import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DeviceData, DeviceType } from '../../../../../../../lib/device/device-detection.model';

@Component({
  selector: 'ifc-id-verse-mobile-app-banner',
  templateUrl: './id-verse-mobile-app-banner.component.html',
  styleUrls: ['./id-verse-mobile-app-banner.component.scss'],
  standalone: false
})
export class IdVerseMobileAppBannerComponent {
  @Input() qrCodeUrl: string;
  @Input() appStoreUrl: string;
  @Input() playStoreUrl: string;
  @Input() headerLogoUrl: string;
  @Input() qrLogoUrl: string;
  @Input() deviceData: DeviceData;
  @Output() continueInBrowser = new EventEmitter<void>();

  readonly DeviceType = DeviceType;

  onClickContinueInBrowser(): void {
    this.continueInBrowser.emit();
  }

  onClickContinueInApp(): void {
    this.navigateTo(this.qrCodeUrl, true);
  }

  onClickGooglePlay(): void {
    this.navigateTo(this.playStoreUrl, true);
  }

  onClickAppleStore(): void {
    this.navigateTo(this.appStoreUrl, true);
  }

  protected navigateTo(url: string, newTab: boolean = false): void {
    if (newTab) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }
    window.location.assign(url);
  }
}
